import React, { useContext, useState } from "react";
import { StyleSheet, View, Text, Platform } from "react-native";

import moment from "moment";

import ImageComponent from "../../common/ImageComponent";
import HourGlassIcon from "../../common/icons/HourGlassIcon";
import ElementSmileyIcon from "../../common/icons/elements/ElementSmileyIcon";
import ManaTextInput from "../../common/ManaTextInput";
import ManaEmojiPicker from "../../common/emoji-picker/ManaEmojiPicker";
import ReflectionContext from "../../reflection/ReflectionContext";
import AppTheme from "../../AppTheme";
import appStyles from "../../../appStyles";

export default function EditRoutineMedia({
  routine = {},
  readOnly = false,
  style,
}) {
  const { saveRoutine } = useContext(ReflectionContext) || {};
  const [openEmojiDialog, setOpenEmojiDialog] = useState(false);

  // When creating from TrackHome default name is weekday
  let placeholderText = "";
  if (routine.selectedDate) {
    if (!routine.name) {
      routine.name = moment(routine.selectedDate).format("dddd");
    }
  } else {
    placeholderText = "Enter Routine name";
  }

  const updateName = (name) => {
    saveRoutine({ ...routine, name });
  };

  const updateEmoji = (emoji = {}) => {
    saveRoutine({ ...routine, icon: emoji.unified || emoji.id });
  };

  const openEmojiEditor = () => {
    if (readOnly) return;
    setOpenEmojiDialog(true);
  };

  return (
    <>
      <ManaEmojiPicker
        isOpen={openEmojiDialog}
        onConfirm={updateEmoji}
        onClose={() => setOpenEmojiDialog(false)}
      />

      <View style={[styles.whiteContainer, styles.shadow, style]}>
        <View style={[styles.imageContainer]}>
          {routine.icon ? (
            <ImageComponent
              styles={styles.icon}
              icon={routine && routine.icon}
              onPress={openEmojiEditor}
            />
          ) : (
            <ElementSmileyIcon
              style={styles.routineIcon}
              onPress={openEmojiEditor}
            />
          )}
        </View>

        <ManaTextInput
          readOnly={readOnly}
          contentHeight={40}
          style={styles.input}
          placeholderTextColor="#ABADB3"
          name={"routineEdit"}
          placeholder={placeholderText}
          onTextChanged={(text) => updateName(text)}
          value={routine.name || ""}
          debounceDelay={500}
        />
      </View>

      {routine.time_interval == "week" ? (
        <View style={[styles.whiteContainer, styles.shadow]}>
          <HourGlassIcon style={appStyles.iconContainer} />
          <Text style={styles.headerText}>Hours</Text>
          <View style={styles.daysContainer}>
            <Text style={[styles.dayText, styles.dayTextP]}>Day</Text>
            <Text style={[styles.dayText, styles.dayTextP]}>Week</Text>
          </View>
        </View>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  whiteContainer: {
    backgroundColor: "#FFF",
    borderRadius: 4,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 40,
    paddingLeft: 8,
    marginTop: 8,
    marginHorizontal: 10,
  },
  headerText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    flex: 1,
  },
  daysContainer: {
    width: 80,
    height: 40,
    marginRight: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  dayText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    letterSpacing: 0.175,
    textAlign: "center",
    color: AppTheme.almostBlack,
    width: 44,
  },
  dayTextP: Platform.select({
    web: {
      fontSize: 14,
      lineHeight: 17,
    },
    ios: {
      fontSize: 12,
      lineHeight: 15,
    },
    android: {
      fontSize: 12,
      lineHeight: 15,
    },
  }),
  routineIcon: {
    width: 30,
    height: 30,
    marginRight: 8,
  },
  icon: {
    width: 30,
    height: 30,
    marginRight: 8,
  },
  shadow: {
    shadowColor: "#000",
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 5,
    elevation: 5,
  },
  input: {
    marginBottom: 0,
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    flex: 1,
    shadowOpacity: 0,
    paddingHorizontal: 0,
    maxHeight: 40,
  },
  imageContainer: {
    width: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
});
